'use client'

import { useState } from 'react'
import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import { toCamelCase } from '@nwwp/utils'
import { useVeritonic } from '@nwwp/veritonic'
import { useFunnelStore } from '../_hooks/use-funnel-store'

type Props = {
  url: string
  utm?: Record<string, string>
}

export const CalendlyScheduler = ({ url, utm: propUtm }: Props) => {
  const { data, tracking } = useFunnelStore()
  const { trackFlowComplete, trackScheduleMeeting } = useVeritonic()
  const [height, setHeight] = useState('500px')

  useCalendlyEventListener({
    onPageHeightResize: (e) => setHeight(e.data.payload.height),
    onEventScheduled: () => {
      trackFlowComplete()
      trackScheduleMeeting()
    },
  })

  const utm = Object.fromEntries(Object.entries(tracking).map(([key, value]) => [toCamelCase(key), value]))

  return (
    <div className="mt-6 overflow-hidden rounded-lg tablet:mt-0 tablet:overflow-visible">
      <InlineWidget
        url={url}
        styles={{ height, minHeight: 500 }}
        prefill={{ name: `${data.first_name} ${data.last_name}`, email: data.email, location: data.zip_code }}
        utm={propUtm || utm}
        pageSettings={{ hideGdprBanner: true, hideLandingPageDetails: true }}
      />
    </div>
  )
}
